"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleLoginButton = void 0;
var GoogleLoginButton_1 = require("./GoogleLoginButton");
Object.defineProperty(exports, "GoogleLoginButton", { enumerable: true, get: function () { return GoogleLoginButton_1.GoogleLoginButton; } });
